import { strictify } from '~/utils/strictify'
import type { PartnerReportIndexQuery } from '~/services/api/generated'
import { PartnerReportIndexSuccessSchema } from '~/services/api/generated'
import { PartnerReportIndex } from '~/services/api/contracts/requests/PartnerReportIndex'
import { createRequestOperation } from '~/utils/createRequestOperation'
import { normalizeReportsPayload } from './normalizeReportsPayload'

export function useReportsService() {
  const baseURL = `${useRuntimeConfig().public.apiBaseUrl}/api/dashboard/reports`
  const client = useApiRequest()

  return {
    get: createRequestOperation(
      client,
      strictify(PartnerReportIndexSuccessSchema),
      (query?: PartnerReportIndexQuery) => ({
        url: baseURL,
        options: { method: 'GET', query: PartnerReportIndex({}).parse(query ?? {}) }
      }),
      normalizeReportsPayload
    )
  }
}
